module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.locales), function(l) {
    return _c('div', {
      staticClass: "locale-textarea"
    }, [_c('textarea', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (l === _vm.currentLocale),
        expression: "l === currentLocale"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": ("input-locale-" + _vm.id + "-" + l),
        "maxlength": _vm.attrs.maxlength,
        "placeholder": ((_vm.attrs.placeholder) + " (" + l + ")"),
        "disabled": _vm.attrs.disabled,
        "rows": _vm.attrs.rows,
        "autofocus": _vm.attrs.autofocus
      },
      domProps: {
        "value": _vm.value[l]
      },
      on: {
        "blur": _vm.validate,
        "input": function($event) {
          return _vm.setValue(l, $event)
        }
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-751739e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/InputLocalizedText.vue
// module id = 1057
// module chunks = 1